import { z } from 'zod'

export const CompareOperatorSchema = z.enum([
  '=',
  '!=',
  '<',
  '<=',
  '>',
  '>=',
  'contains',
  'startsWith',
  'endsWith',
  'in',
  'exists',
  'matches',
])
export type CompareOperator = z.infer<typeof CompareOperatorSchema>

export type CompareExpression = {
  op: 'compare'
  field: string
  operator: CompareOperator
  value: unknown
}

export type AndExpression = {
  op: 'and'
  operands: RuleExpression[]
}

export type OrExpression = {
  op: 'or'
  operands: RuleExpression[]
}

export type NotExpression = {
  op: 'not'
  operand: RuleExpression
}

export type RuleExpression =
  | CompareExpression
  | AndExpression
  | OrExpression
  | NotExpression

export const CompareExpressionSchema: z.ZodType<CompareExpression> = z.object({
  op: z.literal('compare'),
  field: z.string(),
  operator: CompareOperatorSchema,
  value: z.unknown(),
}) as z.ZodType<CompareExpression>

export const RuleExpressionSchema: z.ZodType<RuleExpression> = z.lazy(() =>
  z.union([
    CompareExpressionSchema,
    z.object({
      op: z.literal('and'),
      operands: z.array(RuleExpressionSchema).min(1),
    }),
    z.object({
      op: z.literal('or'),
      operands: z.array(RuleExpressionSchema).min(1),
    }),
    z.object({
      op: z.literal('not'),
      operand: RuleExpressionSchema,
    }),
  ])
)

export const AssignmentsSchema = z.object({
  templateId: z.string().optional(),
  printerProfileId: z.string().optional(),
  propOverrides: z.record(z.string(), z.unknown()).optional(),
  tags: z.array(z.string()).optional(),
})
export type Assignments = z.infer<typeof AssignmentsSchema>

export const AssignmentRuleSchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1),
  description: z.string().optional(),
  priority: z.number().int().optional(),
  enabled: z.boolean().optional(),
  condition: RuleExpressionSchema,
  assignments: AssignmentsSchema,
  createdAt: z.string().datetime().optional(),
  updatedAt: z.string().datetime().optional(),
})
export type AssignmentRule = z.infer<typeof AssignmentRuleSchema>

export const AssignmentRuleMetaSchema = AssignmentRuleSchema.pick({
  id: true,
  name: true,
  description: true,
  priority: true,
  enabled: true,
  updatedAt: true,
})
export type AssignmentRuleMeta = z.infer<typeof AssignmentRuleMetaSchema>
